import { render, staticRenderFns } from "./orderSplitLog.vue?vue&type=template&id=a921b7f4&scoped=true&"
import script from "./orderSplitLog.vue?vue&type=script&lang=js&"
export * from "./orderSplitLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a921b7f4",
  null
  
)

export default component.exports